import ColaboradorView from "../../components/rh/ColaboradorView";

export default function ColaboradorRh() {
  return <ColaboradorView />;
}
